import { ReactElement } from "react";
import { T } from "react-translator-component";
import { Avatar, Box, List } from "@mui/material";
import { colors } from "../../../common/colors";
import { convertUserImage } from "../../../util/utils";
import CopyText from "../CopyText";

interface Props {
  postEventUsers: any[];
}

export default function EventApprovedUsers({ postEventUsers }: Props): ReactElement {

  return (
    <div style={styles.container}>
      <div style={styles.userCount}>
        {T("mng_event_application_users_count")}：{postEventUsers.length}
      </div>

      <div style={styles.userList}>
        <List sx={styles.userBox}>
          {postEventUsers.map((user: any, index: number) => (
            <Box key={index} sx={styles.itemContainer}>
              <Avatar
                sx={styles.userImage}
                src={convertUserImage(user?.image)}
              />
              <span style={styles.nameText}>
                <CopyText text={user?.nickname} />
              </span>
              <span style={styles.nameText}>
                <CopyText text={user?.external_id} />
              </span>
            </Box>
          ))}
        </List>
      </div>
    </div>
  );
};

const styles = {
  container: { width: "100%" },
  userCount: { margin: "10px auto" },
  userList: {
    maxHeight: "calc(100vh*0.9*0.7 - 90px)",
    overflowY: "auto" as const,
  },
  userBox: {
    "& .MuiListItemButton-root:hover": {
      bgcolor: colors.farm_gray10,
      "&, & .MuiListItemIcon-root": {
        color: "black",
      },
      "&$focusVisible": {
        backgroundColor: colors.farm_gray10,
      },
      "& .MuiListItemButton-root:touch": {
        bgcolor: colors.farm_gray10,
        "&, & .MuiListItemIcon-root": {
          color: "black",
        },
      },
    },
    padding: "20px",
    marginBottom: "20px",
  },
  itemContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "16px",
    marginBottom: "16px",
    borderBottomStyle: "solid" as const,
    borderBottomColor: colors.farm_gray100,
    borderBottomWidth: 1,
  },
  userImage: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    objectFit: "cover",
    marginLeft: "10px",
  },
  nameText: {
    fontSize: 14,
    marginLeft: "10px",
    marginBottom: "0px",
    flex: 1,
    textAlign: "left" as const,
    width: "100%"
  },
}
